import { inject, Injectable } from "@angular/core";
import { DataService } from "../../../../../services/data.service";
import { EnvironmentService } from "../../../../../services/environment.service";
import { AppStateService } from "../../../app/app.state.service";
import { Observable } from "rxjs";
import { OrderApiResponseData } from "../../../../../models/order/api-models/order-api-response.model";
import { OrderV2 } from "../../../../../models/order/order.model";
import { ApiCacheTypes } from "../../order.state.wrapper.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class OrderApiCacheService {
  #environmentService = inject(EnvironmentService)
  #dataService = inject(DataService)
  #appStateService = inject(AppStateService)
  #cacheUrl = this.#environmentService.getUrl('cache/')

  getOrderApiCache(orderNumber: string): Observable<OrderApiResponseData> {
    const sessionId = this.getSessionId();
    const endpoint = this.#cacheUrl + sessionId;

    const payload = {
      OrderNumber: orderNumber,
      Types: Object.values(ApiCacheTypes)
    }
    return this.#dataService.post<unknown, OrderApiResponseData>(endpoint, payload, new HttpHeaders().set('Content-Type', 'application/json'))
  }

  setOrderApiDataCache(order: OrderV2): Observable<any> {
    const sessionId = this.getSessionId();
    const endpoint = this.#cacheUrl + sessionId;

    const payload = {
      OrderNumber: order.orderNumber,
      Value: JSON.stringify(order),
      Key: 'ORDER_DATA'
    }
    return this.#dataService.put<unknown, any>(endpoint, payload, new HttpHeaders().set('Content-Type', 'application/json'))
  }

  private getSessionId(): string {
    return this.#appStateService.getSession()?.SessionID;
  }

  removeCacheDataByOrder(order:OrderV2, ProductType){
    const sessionId = this.getSessionId();
    const endpoint = this.#cacheUrl + sessionId;

    const payload = {
      OrderNumber: order.orderNumber,
      Types: ProductType
    }
    return this.#dataService.delete<unknown, any>(endpoint, payload, new HttpHeaders().set('Content-Type', 'application/json'))
  }
}